import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import BootstrapInput from './BootstrapInput';

const useStyles = makeStyles((theme) => ({
  input: {
    borderColor: (props) => (props.error ? theme.palette.error.main : '#ced4da'),
  },
}));

const MyInputText = (props) => {
  const {
    name,
    value,
    defaultValue,
    onChange,
    inputRef,

    disabled,
    error,

    autoFocus,
    multiline,
    type,
    placeholder,
  } = props;
  const classes = useStyles({ error });

  // When type === currency and is uncontrolled, real value is stored in
  // `raw-value` attribute.
  const [rawValue, setRawValue] = React.useState(defaultValue);

  return type === 'currency' ? (
    <NumberFormat
      id={name}
      classes={{ input: classes.input }}
      value={value}
      defaultValue={defaultValue}
      inputProps={{
        'raw-value': rawValue,
      }}
      onValueChange={
        (values) => {
          setRawValue(values.value);
          if (!onChange) return;

          if (values.value !== value) {
            onChange({
              target: {
                name,
                value: values.value,
              },
            });
          }
        }
      }
      customInput={BootstrapInput}
      prefix="Rp "
      decimalSeparator=","
      thousandSeparator="."
      placeholder={placeholder}
      disabled={disabled}
      autoFocus={autoFocus}
      inputRef={inputRef}
    />
  )
    : (
      <BootstrapInput
        id={name}
        classes={{ input: classes.input }}
        name={name}
        value={value}
        defaultValue={defaultValue}
        type={type}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        inputRef={inputRef}
        multiline={multiline}
      />
    );
};

MyInputText.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  inputRef: PropTypes.any,

  disabled: PropTypes.bool,
  error: PropTypes.bool,

  autoFocus: PropTypes.bool,
  multiline: PropTypes.bool,
  placeholder: PropTypes.node,
  type: PropTypes.oneOf(['text', 'currency', 'number', 'password', 'email']),
};

MyInputText.defaultProps = {
  value: undefined,
  onChange: undefined,
  defaultValue: undefined,
  inputRef: undefined,

  disabled: false,
  error: false,

  autoFocus: false,
  multiline: false,
  placeholder: '',
  type: 'text',
};

export default MyInputText;
